let _featureFlags = {};

const init = ({ props = {} }) => {
    const featureFlags = props.featureFlags || {};

    _featureFlags = {
        ...featureFlags,
    };
};

const hasFeatureFlag = ({ key }) => !!_featureFlags[key];

export default {
    init,
    hasFeatureFlag,
};
